import { PayrollServiceData } from './usePayrollService.interface';

import collectiveApi from 'modules/common/collectiveApi';

const fetchPayrollService = async (): Promise<PayrollServiceData> => {
    const { data } = await collectiveApi.get<PayrollServiceData>('payroll/service/');

    return data;
};

export default fetchPayrollService;
